export default "__VITE_PUBLIC_ASSET__27c2178e__"